import { Link } from "react-router-dom"

const BtnOrange = ({text}) => {
  return (
    <Link className="z-btn-home z-btn-transparent-home d-grid" to="/contact">{text}</Link>
  )
}

export default BtnOrange